import { service } from '@maia/cart';
import {
  Button,
  cardStyles,
  PageHeader,
  SectionWithHeader,
  SpecList,
} from '@maia/ui';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';
import { getCancellationQuestionsOptions } from '../../../../features/cancel-insurance/get-questions/queryOptions';

export const Route = createFileRoute(
  '/_authenticated/cancel-insurance/$customer/cart/$cart/insurance/$insurance/_layout/summary',
)({
  component: RouteComponent,
  loader: async ({
    context: { queryClient },
    params: { customer, cart, insurance },
  }) => {
    return queryClient.ensureQueryData(
      getCancellationQuestionsOptions({
        cancellationGuid: cart,
        insuranceGuid: insurance,
        customerGuid: customer,
      }),
    );
  },
});

function RouteComponent() {
  const { cart, customer, insurance } = Route.useParams();
  const data = Route.useLoaderData();
  const navigate = useNavigate();

  const { mutate, isPending } = useMutation({
    mutationFn: () =>
      service.submitCancellation({
        cancellationGuid: cart,
        customerGuid: customer,
      }),
    onSuccess: () => {
      return navigate({
        to: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance/success',
        params: {
          customer,
          cart,
          insurance,
        },
      });
    },
  });

  const specs = data.questions.filter((q) => !!q.answer.value);

  return (
    <>
      <PageHeader
        backLink={{
          to: '/cancel-insurance/$customer/cart/$cart/insurance/$insurance',
          params: { guid: insurance },
        }}
        title="Overzicht op te zeggen verzekering"
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <div className="col-span-full">
          <div className="flex flex-col gap-y-24">
            <SectionWithHeader
              title="Opzegginggegevens"
              className="col-span-full"
            >
              <div
                className={twMerge(cardStyles({ variant: 'outlined' }), 'p-20')}
              >
                <SpecList
                  items={[
                    {
                      title: 'Geannuleerde verzekering',
                      value: data.insurance.name,
                      isHalf: true,
                    },
                  ]}
                />
              </div>
            </SectionWithHeader>

            {specs.length > 0 && (
              <SectionWithHeader title="Gegevens" className="col-span-full">
                <div
                  className={twMerge(
                    cardStyles({ variant: 'outlined' }),
                    'p-20',
                  )}
                >
                  <SpecList
                    items={specs.map((q) => ({
                      title: q.phrasing,
                      value: q.answer.toString(),
                      isHalf: true,
                    }))}
                  />
                </div>
              </SectionWithHeader>
            )}
            <Button
              intent="error"
              onPress={() => mutate()}
              className="w-fit ml-auto"
              isDisabled={isPending}
              isLoading={isPending}
            >
              Verzekering opzeggen
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
